// extracted by mini-css-extract-plugin
export default {"FiltersMobileMenu":"FiltersMobileMenu_FiltersMobileMenu__QRz2f","title":"FiltersMobileMenu_title__gvdaZ","filtersListWrapper":"FiltersMobileMenu_filtersListWrapper__1n8n7"};